export default {
	properties: [
		{
			text: 'Calle',
			key: 'street',
			type: 'text',
			value: '',
			use_in_select: true,
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Tarea',
	plural_model_name_spanish: 'Tareas',
	create_model_name_spanish: 'Nueva',
	text_delete: 'la',
}